import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
// @mui
import { useEffect, useState } from 'react';
import { useLocales } from 'src/legacy/locales';

const IdleConfirmDialog = ({
  getRemainingTime,
  message,
  open,
}: {
  getRemainingTime: () => number;
  message: (data: string, emitOnSelf?: boolean) => void;
  open: boolean;
}) => {
  const { translate } = useLocales();
  const [seconds, setTime] = useState(30);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime]);

  return (
    <Dialog fullWidth maxWidth="xs" open={open}>
      <DialogContent sx={{ textAlign: 'center', typography: 'body2' }}>
        <Typography mt={3} variant="subtitle1">{`${translate(
          'you_have_been_inactive'
        )}`}</Typography>
        <Typography sx={{ margin: 'auto', width: 'fit-content' }} variant="h1">
          {seconds}
        </Typography>
        <Typography variant="subtitle1">{`${translate(
          'do_you_want_to_stay_log_in'
        )}`}</Typography>
      </DialogContent>

      <DialogActions sx={{ margin: 'auto' }}>
        <Button
          color="inherit"
          onClick={() => {
            message('CLOSE', true);
          }}
          variant="outlined"
        >
          {`${translate('yes')}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IdleConfirmDialog;
